<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/125NJiY/tc-custom/9781504089593.jpg?1741151480389" alt="This image is the cover for the book Serial Killer's Son"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Serial Killer's Son
      </h1>
      <p class="bookDescription body article font2">
        <b>He survived—but can he ever truly escape? A chilling psychological novel about damage, desperation, and a man trapped by childhood trauma.</b><br/><br/> When Monty was a child, he killed his father. His father had been kidnapping and murdering women for years, and forcing Monty to help. Monty survived—physically. He was adopted by a wonderful, caring family and is now a wealthy and successful man. On the outside.<br/><br/> But now, the last of his adoptive family has died. Monty lives alone in his beautiful manor house in rural northern England, and the closest thing he has to a friend is his faithful employee, George.<br/><br/> Monty has tried to live a good life, but his father’s deeds haunt him. And with each passing day he’s finding it more difficult to fight against the blood that runs through his veins . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charlotte Stevenson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6da00bd5